import { PRProcessRequest } from '@app/models/pr_processes/PRProcessRequest';
import {
  PRProcessTableData,
  PRProcessTableRow,
  PRProcessResponse,
  PRProcessApiData,
} from '@app/models/pr_processes/PRProcessResponse';
import { post, get } from './http.api';
import { Parameters } from '@app/models/Parameters';

export const getPRProcessTableData = async (parameters: Parameters): Promise<PRProcessTableData> => {
  try {
    const { data, status } = await get<any>('pr_processes', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const PRProcesses: PRProcessTableRow[] = data?.pr_processes?.data?.map((pr_process: any) => ({
      id: pr_process.id,
      pr_product: pr_process.pr_product.name,
      pr_type: pr_process.pr_type,
      validity: `${pr_process.validity} ${pr_process.validity_unit}`,
    }));

    return {
      data: PRProcesses,
      status_options: data.status_options,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Processes:', error);
    throw error;
  }
};

export const getAllPRProcesses = async (): Promise<PRProcessResponse> => {
  try {
    const { data, status } = await get<PRProcessResponse>(`pr_processes`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPRProcessById = async (id: number): Promise<PRProcessResponse> => {
  try {
    const { data, status } = await get<PRProcessResponse>(`pr_processes/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storePRProcess = async (ProcessData: PRProcessRequest) => {
  try {
    const response = await post<any>('pr_processes/create', ProcessData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createPRProcess = async (): Promise<PRProcessApiData> => {
  try {
    const { data, status } = await get<PRProcessApiData>(`pr_processes/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showPRProcess = async (id: number) => {
  try {
    const { data, status } = await get<PRProcessApiData>(`pr_processes/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editPRProcess = async (id: number) => {
  try {
    const { data, status } = await get<PRProcessApiData>(`pr_processes/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updatePRProcess = async (id: number, Updateprocess: PRProcessRequest) => {
  try {
    const { data, status } = await post<PRProcessRequest>(`pr_processes/${id}/edit`, Updateprocess, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
